/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2025-07-14 16:02:35
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbShopReceiptTemplate {
    /**获取门店小票模板 */
    export var GetTbShopReceiptTemplate = (body): Promise<any> => {
        return Get(`/api/TbShopReceiptTemplate/GetTbShopReceiptTemplate`, body);
    };
    /**更新门店小票模板 */
    export var PutShopReceiptTemplate = (body): Promise<any> => {
        return Put(`/api/TbShopReceiptTemplate/PutShopReceiptTemplate`, body);
    };
   
}



// WEBPACK FOOTER //
// ./src/http/api_TbShopReceiptTemplate.ts